export default "__VITE_ASSET__Bg78MhmN__"